import axiosWithAuth from '../utils/axiosWithAuth';
import { getApiEndpoint } from '../utils/apiConfig';

// Tüm ayarları getir
export const getAllSettings = async () => {
  const response = await axiosWithAuth().get(getApiEndpoint('settings'));
  return response.data;
};

// Belirli bir ayarı getir
export const getSetting = async (key) => {
  try {
    const api = axiosWithAuth();
    const response = await api.get(`/settings/${key}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching setting ${key}:`, error);
    throw error;
  }
};

// Ayar güncelle
export const updateSetting = async (key, data) => {
  try {
    console.log(`Calling PUT /settings/${key} with data:`, data);
    const api = axiosWithAuth();
    
    // API request headers'ı log'a ekle
    console.log('Request headers:', api.defaults.headers);
    
    const response = await api.put(`/settings/${key}`, data);
    console.log(`Received response for PUT /settings/${key}:`, response);
    return response.data;
  } catch (error) {
    console.error(`Error updating setting ${key}:`, error);
    console.error('Error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      headers: error.response?.headers
    });
    throw error;
  }
};

// Yeni ayar ekle
export const addSetting = async (data) => {
  try {
    const api = axiosWithAuth();
    const response = await api.post('/settings', data);
    return response.data;
  } catch (error) {
    console.error('Error adding setting:', error);
    throw error;
  }
};

// createSetting - addSetting ile aynı fonksiyonellik
export const createSetting = async (data) => {
  try {
    const api = axiosWithAuth();
    const response = await api.post('/settings', data);
    return response.data;
  } catch (error) {
    console.error('Error creating setting:', error);
    throw error;
  }
};

// Ayar sil
export const deleteSetting = async (key) => {
  try {
    const api = axiosWithAuth();
    const response = await api.delete(`/settings/${key}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting setting ${key}:`, error);
    throw error;
  }
};

// Toplu ayar silme
export const bulkDeleteSettings = async (keys) => {
  try {
    const api = axiosWithAuth();
    const response = await api.post('/settings/bulk-delete', { keys });
    return response.data;
  } catch (error) {
    console.error('Error deleting settings in bulk:', error);
    throw error;
  }
};

// Get public settings
export const getPublicSettings = async () => {
  const response = await axiosWithAuth().get(getApiEndpoint('settings/public'));
  return response.data;
};

export const getDoorAndWindowPrices = async (styleId, tariffId) => {
  try {
    // Check if both IDs are valid
    if (!styleId || !tariffId) {
      console.error('Invalid styleId or tariffId:', { styleId, tariffId });
      throw new Error('Invalid styleId or tariffId');
    }
    
    // Use the correct endpoint based on the backend routes
    const response = await axiosWithAuth().get(
      getApiEndpoint(`settings/prices?styleId=${styleId}&tariffId=${tariffId}`)
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null; // Return null if prices don't exist
    }
    throw error;
  }
};

export const updateStyleTariffPrices = async ({ type, styleId, tariffId, prices, method = 'POST' }) => {
  try {
    // Use the correct endpoint based on the backend routes
    const endpoint = getApiEndpoint(`settings/prices`);
    
    const data = {
      styleId,
      tariffId,
      prices: {
        [type]: prices
      }
    };

    console.log(`Making ${method} request to ${endpoint} with data:`, data);

    const response = method === 'PUT' 
      ? await axiosWithAuth().put(endpoint, data)
      : await axiosWithAuth().post(endpoint, data);

    return response.data;
  } catch (error) {
    console.error('Error updating style-tariff prices:', error);
    throw error;
  }
}; 